import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import AddressFormat from '@fragaria/address-formatter';
import { CountryNamePipe } from '../../providers/country-name.pipe';

export type Address = {
  countryCode: string;

  postalCode?: string;

  nameLatin?: string;
  name?: string;

  // city
  localityLatin?: string;
  locality?: string;

  cityDistrictLatin?: string;
  cityDistrict?: string;

  // state
  administrativeAreaLatin?: string;
  administrativeArea?: string;

  // street
  addressLine1Latin?: string;
  addressLine1?: string;

  houseLatin?: string;
  house?: string;
  streetNo?: string;

  addressLine2Latin?: string;
  addressLine2?: string;
}

@Component({
    selector: 'app-address',
    imports: [
        CountryNamePipe,
    ],
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressComponent implements OnChanges {

  @Input() public address!: Address;

  protected formattedLines!: string[];

  public ngOnChanges(): void {
    const lines = AddressFormat.format({
      countryCode: this.address.countryCode,
      postcode: this.address.postalCode,
      road: this.address.addressLine1Latin,
      house: this.address.houseLatin,
      houseNumber: this.address.streetNo,
      state: this.address.administrativeAreaLatin,
      locality: this.address.localityLatin,
      cityDistrict: (this.address.cityDistrictLatin ?? '') + (this.address.addressLine2Latin ? (this.address.cityDistrictLatin ? ` ${this.address.addressLine2Latin}` : this.address.addressLine2Latin) : ''),
    }, {
      output: 'array',
    });

    if (this.address.addressLine1 || this.address.name || this.address.locality) {
      lines.push('', ...AddressFormat.format({
        countryCode: this.address.countryCode,
        postcode: this.address.postalCode,
        road: this.address.addressLine1,
        house: this.address.house,
        houseNumber: this.address.streetNo,
        state: this.address.administrativeArea,
        locality: this.address.locality,
        cityDistrict: (this.address.cityDistrict ?? '') + (this.address.addressLine2 ? (this.address.cityDistrict ? ` ${this.address.addressLine2}` : this.address.addressLine2) : ''),
      }, {
        output: 'array',
      }));
    }

    this.formattedLines = lines;
  }

}
